<template>
  <div>
    <v-card tile flat>
      <v-card-text>
        <v-row class="my-5">
          <v-col cols="12" md="12" sm="12">
            <v-row>
              <v-col cols="12" md="12">
                <h2 class="ml-4">Data {{ jenis === 'luring' ? 'Diklat' : 'Bimtek' }}</h2>
                <base-list-info :info="info" />
              </v-col>
              <v-col cols="12" md="12">
                <v-divider class="my-5" />
              </v-col>
              <v-col cols="12" md="12">
                <h2 class="ml-4">Jadwal Pelaksanaan</h2>
                <base-list-info :info="jadwal" />
              </v-col>

              <!-- Payment Information Section -->
              <v-col v-if="jenis === 'luring'" cols="12" md="12">
                <v-divider class="my-5" />
              </v-col>
              <v-col cols="12" md="12">
                <h2 class="ml-4">Informasi Pembiayaan</h2>
                <base-list-info :info="pembayaranInfo" />
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import BaseListInfo from '@components/base/BaseListInfo.vue';
export default {
  components: { BaseListInfo },
  props: {
    initValue: {
      type: Object,
      default: () => null,
    },
    jenis: {
      type: String,
      default: 'daring',
    },
  },
  computed: {
    pembayaranInfo() {
      const detail = this.initValue || {};
      const pembiayaan = this.$getDeepObj(detail, 'm_pembiayaan_paud.data');

      const isUrl = (str) => {
        try {
          new URL(str);
          return true;
        } catch {
          return false;
        }
      };

      const urlToLink = (url, text = 'Lihat Berkas') => {
        return `<a href="${url}"  class="blue--text" target="_blank" rel="noopener noreferrer">${text}</a>`;
      };

      const infoItems = [
        {
          key: 'jenis_pembiayaan',
          label: 'Jenis Pembiayaan',
          value: pembiayaan ? pembiayaan.keterangan : '-',
        },
      ];

      // Only add additional fields if k_pembiayaan_paud is not 1
      if (detail.k_pembiayaan_paud !== 1) {
        infoItems.push(
          {
            key: 'csr_instansi',
            label: 'Nama Instansi',
            value: detail.csr_instansi || '-',
          },
          {
            key: 'csr_nama',
            label: 'Nama Penandatangan',
            value: detail.csr_nama || '-',
          },
          {
            key: 'csr_jabatan',
            label: 'Jabatan',
            value: detail.csr_jabatan || '-',
          }
        );

        // Add file links if they exist
        if (detail.csr_logo_url) {
          infoItems.push({
            key: 'logo_instansi',
            label: 'Logo Instansi',
            value: isUrl(detail.csr_logo_url) ? urlToLink(detail.csr_logo_url) : detail.csr_logo_url,
            isLink: false,
            isHtml: true,
          });
        }

        if (detail.csr_ttd_url) {
          infoItems.push({
            key: 'ttd_instansi',
            label: 'TTD Instansi',
            value: isUrl(detail.csr_ttd_url) ? urlToLink(detail.csr_ttd_url) : detail.csr_ttd_url,
            isLink: false,
            isHtml: true,
          });
        }

        if (detail.csr_stempel_url) {
          infoItems.push({
            key: 'stempel_instansi',
            label: 'Stempel Instansi',
            value: isUrl(detail.csr_stempel_url) ? urlToLink(detail.csr_stempel_url) : detail.csr_stempel_url,
            isLink: false,
            isHtml: true,
          });
        }
      }

      return [infoItems];
    },

    info() {
      const detail = this.initValue || {};
      let temp = [
        [
          {
            key: 'nama',
            label: `Nama ${this.jenis === 'luring' ? 'Diklat' : 'Bimtek'}`,
            value: this.$getDeepObj(detail, 'nama') || '-',
          },
        ],
      ];

      if (this.jenis !== 'luring') {
        temp.push([
          {
            key: 'pilihan',
            label: 'Pilihan Moda Bimtek',
            value: this.$getDeepObj(detail, 'm_moda_paud.data.keterangan') || '-',
          },
          {
            key: 'kategori',
            label: 'Kategori Bimtek',
            value: this.$getDeepObj(detail, 'm_diklat_bimtek_paud.data.keterangan') || '-',
          },
        ]);

        temp.push([
          {
            key: 'jenis',
            label: 'Jenis Bimtek',
            value: this.$getDeepObj(detail, 'm_diklat_bimtek_paud.data.keterangan') || '-',
          },
          {
            key: 'jenjang',
            label: 'Jenjang Bimtek',
            value: this.$getDeepObj(detail, 'm_jenjang_diklat_paud.data.keterangan') || '-',
          },
        ]);
      } else {
        temp.push([
          {
            key: 'jenis',
            label: 'Jenis Diklat',
            value: this.$getDeepObj(detail, 'm_diklat_paud.data.keterangan') || '-',
          },
          {
            key: 'jenjang',
            label: 'Jenjang Diklat',
            value: this.$getDeepObj(detail, 'm_jenjang_diklat_paud.data.keterangan') || '-',
          },
        ]);

        temp.push([
          {
            key: 'jenis_pembiayaan',
            label: 'Jenis Pembiayaan Diklat',
            value: this.$getDeepObj(detail, 'm_pembiayaan_paud.data.keterangan') || '-',
          },
          {
            key: 'deskripsi',
            label: 'Deskripsi',
            value: this.$getDeepObj(detail, 'deskripsi') || '-',
          },
        ]);
      }

      temp.push([
        {
          key: 'propinsi',
          label: 'Provinsi',
          value: this.$getDeepObj(detail, 'm_propinsi.data.keterangan') || '-',
        },
        {
          key: 'kota',
          label: 'Kota/Kabupaten',
          value: this.$getDeepObj(detail, 'm_kota.data.keterangan') || '-',
        },
      ]);

      return temp;
    },
    jadwal() {
      const detail = this.initValue || {};
      return [
        [
          {
            key: 'tgl_mulai',
            label: 'Tanggal Mulai',
            value: this.$localDate(this.$getDeepObj(detail, 'tgl_mulai')),
          },
          {
            key: 'tgl_selesai',
            label: 'Tanggal Selesai',
            value: this.$localDate(this.$getDeepObj(detail, 'tgl_selesai')),
          },
        ],
      ];
    },
  },
};
</script>
